import Flickity from 'flickity';
import FlickityFade from 'flickity-fade';

const Carousel = () => {

    var galleryElems = document.querySelectorAll('.carousel');
    var carouselStatus = document.querySelector('.carousel__count');

    for ( var i=0, len = galleryElems.length; i < len; i++ ) {
        var galleryElem = galleryElems[i];
        var flkty = new Flickity( galleryElem, {
            pageDots: true,
            autoPlay: false,
            lazyLoad: false,
            fade: false,
            adaptiveHeight: true
        });
        function updateStatus() {
            var slideNumber = flkty.selectedIndex + 1;
            carouselStatus.textContent = slideNumber + '/' + flkty.slides.length;
        }
        updateStatus();

        flkty.on( 'select', updateStatus );
    }
}

export default Carousel;
